import getInstanceAxios from 'utils/requestManager/RequestGlobalConfig'

export const author = getInstanceAxios(process.env.REACT_APP_BASE_API_EPR)
